export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL'
export const SET_ORDERS_ORDERS = 'SET_ORDERS_ORDERS'
export const SET_ORDERS_ORDER_SUMMARY_PREVIEW = 'SET_ORDERS_ORDER_SUMMARY_PREVIEW'
export const FETCH_UNIT_SUMMARY_REPORT_DATA = 'FETCH_UNIT_SUMMARY_REPORT_DATA'
export const PATCH_UNIT_SUMMARY_TOTALS = 'PATCH_UNIT_SUMMARY_TOTALS'
export const REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT'
export const ADD_ORDER_PRODUCTS = 'ADD_ORDER_PRODUCTS'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const CLEAR_ACTIVE_DRAFT_ORDER = 'CLEAR_ACTIVE_DRAFT_ORDER'
export const SET_NEW_ORDER_MODE = 'SET_NEW_ORDER_MODE'
export const ADD_ORDER = 'ADD_ORDER'
export const REMOVE_ORDER = 'REMOVE_ORDER'
export const ADD_ORDER_PRODUCT = 'ADD_ORDER_PRODUCT'
export const SET_NEW_ORDER_PRODUCT = 'SET_NEW_ORDER_PRODUCT'
export const CLEAR_NEW_ORDER_PRODUCT = 'CLEAR_NEW_ORDER_PRODUCT'
export const SET_ACTIVE_DRAFT_ORDER = 'SET_ACTIVE_DRAFT_ORDER'
export const BULK_DELETE_DRAFT_ORDER = 'BULK_DELETE_DRAFT_ORDER'
export const ORDER_HAS_PRODUCT_QUANTITIES = 'ORDER_HAS_PRODUCT_QUANTITIES'
export const SET_EXCEED_QUANTITY_PRODUCT = 'SET_EXCEED_QUANTITY_PRODUCT'
export const INSUFFICIENT_QUANTITY_SELECTED_PRODUCT = 'INSUFFICIENT_QUANTITY_SELECTED_PRODUCT'
export const ACTION_REQUIRED_SELECTED_OPTION = 'ACTION_REQUIRED_SELECTED_OPTION'
export const SET_TOTAL_ORDER_PAGES = 'SET_TOTAL_ORDER_PAGES'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_TOTAL_ORDERS = 'SET_TOTAL_ORDERS'
export const SET_CURRENT_COMPLETED_ORDER_PAGE = 'SET_CURRENT_COMPLETED_ORDER_PAGE'
export const SET_TOTAL_COMPLETED_ORDER_PAGES = 'SET_TOTAL_COMPLETED_ORDER_PAGES'
export const SET_TOTAL_COMPLETED_ORDERS = 'SET_TOTAL_COMPLETED_ORDERS'
export const SET_COMPLETED_ORDERS = 'SET_COMPLETED_ORDERS'
export const SET_CURRENT_PAGE_ORDER = 'SET_CURRENT_PAGE_ORDER'
export const SET_TOTAL_PAGE_ORDER_PAGES = 'SET_TOTAL_PAGE_ORDER_PAGES'
export const SET_TOTAL_PAGE_ORDERS = 'SET_TOTAL_PAGE_ORDERS'
export const SET_ORDERS_PAGE_ORDERS = 'SET_ORDERS_PAGE_ORDERS'
export const SET_VALIDATION_RESPONSE = 'SET_VALIDATION_RESPONSE'
